import React, { Component } from "react";
import { formatISO, add } from "date-fns";
import { Box, Stack, HStack, Text, Button, Tag, TagLabel, Switch, FormLabel, VStack, TagRightIcon } from "@chakra-ui/react";
import { Modal, ModalOverlay, ModalContent, ModalFooter, ModalBody, Spacer } from '@chakra-ui/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faDownload } from "@fortawesome/free-solid-svg-icons";

import { LoremIpsum, Avatar } from 'react-lorem-ipsum';

import _ from "lodash";

import ModalIdNameListDialog from "../../../components/Modals/ModalIdNameListDialog";
import HistorySearchStrip from "./HistorySearchStrip";
import HistoryGrid from "./HistoryGrid";
import ShareDialog from "./ShareDialog";
import FilteredCountPieChart from "../../Dashboard/Components/Charts/FilteredCountPieChart";
import FilteredCountPartitionStackedBarChart from "../../Dashboard/Components/Charts/FilteredCountPartitionStackedBarChart";
import EnterpriseActivityChart from "../../Dashboard/Components/Charts/EnterpriseActivityChart";


import IdentityService from "../../../services/IdentityService";

import ObsSearchParams from "../../../models/ObsSearchParams";
import ObservationDetailPanel from "./ObservationDetailPanel";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageNotFound from "../../../assets/images/ImageNotFound.png";

import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";


import ConfigService from "../../../services/ConfigService";
import LocalStorageService from "../../../services/LocalStorageService";
import CoreService from "../../../services/CoreService";
import { ObservationSessionMode } from "../../../models/ObservationSessionMode";


import SubscriptionManager from "../../../managers/SubscriptionManager";
import DataTransformManager from "../../../managers/DataTransformManager";
import DataApiManager from "../../../managers/DataApiManager";

import RoleManager from "../../../models/RoleManager";
import { AppSecurityKey } from "../../../models/AppSecurityKey";
import ServiceResponse from "../../../models/ServiceResponse";
import WorkflowStep from "../../../models/WorkflowStep";
import JavascriptHelpers from "../../../components/lib/Javascript/JavascriptHelpers";
import { clone } from "lodash";






export default class HistoryPanel extends Component {

    constructor(props) {
        super(props);
        this.state =
        {
            searchParams: new ObsSearchParams(),
            searchParamsKey: null,
            schema: null,
            selectedObservation: null,
            selectedObservationId: null,
            showUserImageBox: false,
            slides: null,
            selectedSlideIndex: 0,
            hasSlides: false,
            showUserDocBox: false,
            docs: null,
            hasDocs: false,
            showShareBox: false,
            schemaReports: [],
            showVoidBox: false,
            voidIdNameList: [],
            autoRefreshIsChecked: false,
            suppressAutoRefresh: false
        }

        this.configService = new ConfigService();
        this.localStorageService = new LocalStorageService();
        this.coreService = new CoreService();

        this.onSearchParamsChange = this.onSearchParamsChange.bind(this);
        this.onObservationSelectionChanged = this.onObservationSelectionChanged.bind(this);

        this.onShowUserImageBox = this.onShowUserImageBox.bind(this);
        this.onCloseUserImageBox = this.onCloseUserImageBox.bind(this);
        this.fetchSlides = this.fetchSlides.bind(this);
        this.onSlide = this.onSlide.bind(this);
        this.onDownloadSelectedImage = this.onDownloadSelectedImage.bind(this);
        this.onShowUserDocBox = this.onShowUserDocBox.bind(this);
        //this.fetchDocs = this.fetchDocs.bind(this);
        this.onCloseUserDocBox = this.onCloseUserDocBox.bind(this);

        this.onShowPdfReport = this.onShowPdfReport.bind(this);

        this.onShowShareBox = this.onShowShareBox.bind(this);
        this.onCloseShareBox = this.onCloseShareBox.bind(this);

        this.onResendSubscriptionNotificationsRequest = this.onResendSubscriptionNotificationsRequest.bind(this);

        this.onDownloadFileFromString = this.onDownloadFileFromString.bind(this);
        this.onDownloadAsJsonRequest = this.onDownloadAsJsonRequest.bind(this);
        this.onDownloadAsStarJsonRequest = this.onDownloadAsStarJsonRequest.bind(this);
        this.onUploadAsJsonRequest = this.onUploadAsJsonRequest.bind(this);
        this.onUploadDimensionsAsJsonRequest = this.onUploadDimensionsAsJsonRequest.bind(this);

        this.onViewReadOnlyRequest = this.onViewReadOnlyRequest.bind(this);
        this.onUpdateRequest = this.onUpdateRequest.bind(this);
        this.onCopyRequest = this.onCopyRequest.bind(this);
        this.onDuplicateRequest = this.onDuplicateRequest.bind(this);
        this.onVoidRequest = this.onVoidRequest.bind(this);
        this.onWorkflowStepRequest = this.onWorkflowStepRequest.bind(this);

        this.onCloseVoidBox = this.onCloseVoidBox.bind(this);
        this.onOkVoidBox = this.onOkVoidBox.bind(this);

    }

    async componentDidMount() 
    {
        var searchParams;
        var hasGlobalSearchParams = this.props.globalSearchParams;
        if (hasGlobalSearchParams)
        {
            searchParams = this.props.globalSearchParams;
        }
        else
        {
            searchParams = new ObsSearchParams();
            searchParams.schemaId = this.props.userSession.currentSchemaId;
           
            searchParams.location =  (RoleManager.hasRoleRights(AppSecurityKey.SEARCH_ALL)) ? this.props.userSession.currentLocationId : "ALL";
            searchParams.observer = (RoleManager.hasRoleRights(AppSecurityKey.SEARCH_ALL)) ? this.props.userSession.uid : "ALL";
            searchParams.eventStartDate = formatISO(add(new Date(), { days: -5 }));
            searchParams.eventEndDate = formatISO(add(new Date(), { days: 1 }));
        }
        var searchKey = ObsSearchParams.toSearchKey(searchParams);
        var voidIdNameListResponse = this.localStorageService.getDataList("voidreasons", this.props.userSession.gcid);
        var voidIdNameList = voidIdNameListResponse.data.data;
        var gradeColorMapResponse = this.localStorageService.getDataList("colormap-grade", this.props.userSession.gcid);
        var gradeColorMap = gradeColorMapResponse.data.data;
        this.setState({ searchParams: searchParams, searchParamsKey: searchKey, voidIdNameList: voidIdNameList, autoRefreshIsChecked: this.props.autoRefresh, gradeColorMap: gradeColorMap })
    }

    onSearchParamsChange(newSearchParams) 
    {
        var searchKey = ObsSearchParams.toSearchKey(newSearchParams);
        var schema = (newSearchParams.schemaId) ? this.localStorageService.getSchema(newSearchParams.schemaId) : {};
        this.setState({ searchParams: newSearchParams, searchParamsKey: searchKey, schema: schema });
        this.props.onGlobalSearchParamsChange(newSearchParams);

    }



    onShowShareBox() 
    {
        if (this.state.selectedObservationId) {
            this.setState({ suppressAutoRefresh: true, showShareBox: true });
        }
    }

    onCloseShareBox() 
    {
        this.setState({ suppressAutoRefresh: false, showShareBox: false });
    }

    async onShowPdfReport(reportId) 
    {
        /*
        var schema = this.localStorageService.getSchema(this.state.selectedObservation.data.schema.id);
        var pdf = new PdfObservation(this.state.selectedObservation, schema, reportId, this.props.userSession.gcid, this.props.userSession.token);
        var pdfResponse = await pdf.writeToCloudStorage();
        if (pdfResponse.hasError) {
            this.props.onMsgBoxRequest('error', 'There was a problem creating and uploading your report.');
            return;
        }
        window.open(pdf.getLinkFromObservation(), "_blank");
        */
       this.props.onViewReportRequest(this.state.selectedObservation, reportId);
    }


    async onResendSubscriptionNotificationsRequest()
    {
        try
        {
        var schema = this.localStorageService.getSchema(this.state.selectedObservation.data.schema.id);
        var subscriptionManager = new SubscriptionManager();
        var result = await subscriptionManager.sendSubscriptions(this.state.selectedObservation, schema, this.props.userSession.uid, this.props.userSession.gcid, this.props.userSession.token);
        console.log("Subscribers (if any) sent events");
        console.info(result);
        this.props.onToastRequest("success", "Subscribers have been sent notifications.");
        } catch(e)
        {
            console.log("Error sending to subscribers");
            console.info(e);
            this.props.onToastRequest("error", "Error sending to subscribers");
        }
    }


    onViewReadOnlyRequest()
    {
        var initialBag = this.state.selectedObservation.data.Raw; // all data
        this.props.onObservationPageRequest(ObservationSessionMode.READONLY, this.state.selectedObservation.data.schema.id, initialBag);

    }

    onUpdateRequest() 
    {
        var schema = this.localStorageService.getSchema(this.state.selectedObservation.data.schema.id);
        var initialBag = this.state.selectedObservation.data.Raw; // all data
        // we need the original Id of the observation we are updating
        initialBag["originalId"] = this.state.selectedObservation.identifiers.id;
        this.props.onObservationPageRequest(ObservationSessionMode.UPDATE, this.state.selectedObservation.data.schema.id, initialBag);
    }


    onDuplicateRequest() 
    {
        var schema = this.localStorageService.getSchema(this.state.selectedObservation.data.schema.id);
        var initialBag = this.state.selectedObservation.data.Raw; // all data
        // we need the original Id of the observation we are updating
        initialBag["originalId"] = this.state.selectedObservation.identifiers.id;
        initialBag["isDuplicate"] = true;
        this.props.onObservationPageRequest(ObservationSessionMode.DUPLICATE, this.state.selectedObservation.data.schema.id, initialBag);
    }


    onCopyRequest() {
        var schema = this.localStorageService.getSchema(this.state.selectedObservation.data.schema.id);
        var copyFields = schema.copy?.copyFields;
        if (!copyFields) {
            this.props.onMsgBoxRequest('error', 'This observation schema does not support copy fields.');
            return;
        }
        var rawBag = this.state.selectedObservation.data.Raw;
        var initialBag = {};
        copyFields.forEach((f) => {
            if (rawBag[f]) initialBag[f] = rawBag[f];
        });
        this.props.onObservationPageRequest(ObservationSessionMode.COPY, this.state.selectedObservation.data.schema.id, initialBag);
    }





    onObservationSelectionChanged(selectedObservation) {
        var slides = this.fetchSlides(selectedObservation);
        //var docs = this.fetchDocs(selectedObservation);
        var historySchemaId = this.state.searchParams.schemaId;
        var schemaReports = this.localStorageService.getSchemaReports(historySchemaId ?? []);



        this.setState({
            selectedObservation: selectedObservation,
            selectedObservationId: selectedObservation?.identifiers?.id,
            hasSlides: (slides.length > 0),
            slides: slides,
            selectedSlideIndex: 0,
            //hasDocs: (docs.length > 0),
            //docs: docs,
            schemaReports: schemaReports
        });
    }

    /*
    fetchDocs(selectedObservation) {
        if (!selectedObservation?.data?.Raw?.userdocs) return [];
        var result = selectedObservation?.data?.Raw?.userdocs.map((rawInfo) => {
            console.log(rawInfo);
            var ext = (rawInfo.ext) ? rawInfo.ext : "pdf";
            var original = this.configService.getGcidUserDocBasePath(this.props.userSession.gcid) + rawInfo.id + "." + ext;
            var description = (rawInfo.descript) ? rawInfo.descript : "";
            var tags = (rawInfo.tags) ? rawInfo.tags : [];
            //return {"uri": original, "description": description, "tags": tags, "ext": ext};
            return { "uri": original };
        });
        return result;
    }
    */
    


    async onWorkflowStepRequest(existingWorkflowStep, newWorkflowStep)
    {
        let nw = formatISO(new Date());
        var workflowNode = new WorkflowStep(this.props.userSession.gcid, newWorkflowStep, existingWorkflowStep, nw, this.props.userSession.uid);
        if (this.state.selectedObservation) {
            var statusEvent = {
                Id: IdentityService.makeUuid(),
                Gcid: this.props.userSession.gcid,
                ObservationId: this.state.selectedObservation.identifiers.id,
                EventDate: nw,
                EventType: "statusChange",
                EventReason: newWorkflowStep,
                EventBy: this.props.userSession.uid,
                EventLocation: this.props.userSession.currentLocationId,
                Changed: {
                    OriginalStatus: existingWorkflowStep ?? "",
                    OriginalStatusReason: "user change",
                },
            };
            let clone = _.cloneDeep(this.state.selectedObservation);
            clone.WorkflowStep = workflowNode;

            //if (this.props.isConnected){
            var postResponse = await this.coreService.postObservationUpdate(statusEvent, clone, this.props.userSession.gcid, this.props.userSession.token);
            if (postResponse.hasError) {
                this.props.onMsgBoxRequest("Error", "Problem posting status step change.", '', 'error');
                return;
            }
            this.props.onToastRequest("info", "Inspection status step has been changed to " + newWorkflowStep + ".");
            // trigger requery
            var newSearchParamsKey = this.state.searchParamsKey + "&q" + statusEvent.ObservationId;
            this.setState({ searchParamsKey: newSearchParamsKey });
        }
    }


    onVoidRequest() 
    {
        if (this.state.selectedObservationId) 
        {
            this.setState({ suppressAutoRefresh: true, showVoidBox: true });
        }
    }

    onCloseVoidBox() {
        this.setState({ suppressAutoRefresh: false, showVoidBox: false });
    }

    async onOkVoidBox(existingValue, newValue) {
        this.setState({ showVoidBox: false });
        if (!newValue || newValue === "") {
            this.props.onMsgBoxRequest("Warning", "Please select a void reason!", '', 'warning');
            return;
        }
        if (this.state.selectedObservation) {
            var voidEvent = {
                Id: IdentityService.makeUuid(),
                Gcid: this.props.userSession.gcid,
                ObservationId: this.state.selectedObservation.identifiers.id,
                EventDate: formatISO(new Date()),
                EventType: "void",
                EventReason: newValue,
                EventBy: this.props.userSession.uid,
                EventLocation: this.props.userSession.currentLocationId,
                Changed: {
                    OriginalStatus:
                        this.state.selectedObservation.identifiers.status ?? "",
                    OriginalStatusReason:
                        this.state.selectedObservation.identifiers.statusReason ?? "",
                },
            };


            //if (this.props.isConnected){
            var postResponse = await this.coreService.postObservationVoid(voidEvent, this.props.userSession.gcid, this.props.userSession.token);
            if (postResponse.hasError) {
                this.props.onMsgBoxRequest("Error", "Problem posting void.", '', 'error');
                return;
            }
            //}
            //else {
            //  await this.localDbService.updateQaObservationPendingToVoid(this.gcid, voidEvent.ObservationId);
            //  await this.localDocService.AddDoc(voidEvent, "voidevent", voidEvent.ObservationId);
            // }
            this.props.onToastRequest("info", "Inspection has been voided.");
            // trigger requery
            var newSearchParamsKey = this.state.searchParamsKey + "&q" + voidEvent.ObservationId;
            this.setState({ searchParamsKey: newSearchParamsKey })
        }
    }


    onShowUserDocBox() 
    {
        if ((!this.state.selectedObservationId) || (!this.state.selectedObservation?.data?.Raw?.userdocs)) 
        {
            this.props.onMsgBoxRequest('warning', 'The selected observation does not have associated user documents.');
            return;
        }
        {

            var documents = this.state.selectedObservation?.data.Raw?.userdocs.map((rawInfo) => {
                console.log(rawInfo);
                var ext = (rawInfo.ext) ? rawInfo.ext : "pdf";
                var original = this.configService.getGcidUserDocBasePath(this.props.userSession.gcid) + rawInfo.id + "." + ext;
                var description = (rawInfo.descript) ? rawInfo.descript : "";
                var tags = (rawInfo.tags) ? rawInfo.tags : [];
                return { "uri": original, description: description, tags: tags };
            });

            // we have to download EACH pdf document locally. We could save this to local storage and feed a dialog
            // but for now I'm just going to download them.  
            for (const doc of documents) 
            {
                try
                {
                    window.open(doc.uri,"_blank");
                    this.props.onToastRequest('info', doc.description + ' has been downloaded to your browser. ');
                }
                catch(e)
                {
                    this.props.onToastRequest('error', 'There was a problem downloading ' + doc.description + " to your browser. ");
                }
            }
            /*
            var viewerDocs = documents.map((d) => {return {uri: d.original}});
            this.setState({docs: viewerDocs, docIdx: 0, activeDoc: viewerDocs[0]});


            this.setState({ suppressAutoRefresh: true, showUserDocBox: true });
            */
        }
    }

    onCloseUserDocBox() {
        // close the box and also reset the docs to the currently selected docs
        var selectedObservation = this.state.selectedObservation;
        //var docs = this.fetchDocs(selectedObservation);
        this.setState({
            //selectedObservation: selectedObservation,
            //hasDocs: (docs.length > 0),
            //docs: docs,
            showUserDocBox: false,
            suppressAutoRefresh: false
        });
    }

    onShowUserImageBox() 
    {
        if ((!this.state.selectedObservationId) || (!this.state.selectedObservation?.data?.Raw?.userimages)) 
        {
            this.props.onMsgBoxRequest('warning', 'The selected observation does not have associated user images.');
            return;
        }
        if (this.state.selectedObservationId && this.state.selectedObservation?.data?.Raw?.userimages) 
        {
            this.setState({ suppressAutoRefresh: true, showUserImageBox: true });
        }
    }

    onCloseUserImageBox()
    {
        this.setState({ suppressAutoRefresh: false, showUserImageBox: false })
    }

    fetchSlides(selectedObservation) {
        if (!selectedObservation?.data?.Raw?.userimages) return [];
        var result = selectedObservation?.data?.Raw?.userimages.map((rawInfo) => {
            console.log(rawInfo);
            var ext = (rawInfo.ext) ? rawInfo.ext : "png";
            // use thumbnail? 
            var original = this.configService.getGcidUserImageBasePath(this.props.userSession.gcid) + rawInfo.id + "." + ext;
            var originalTitle = (rawInfo.title) ? rawInfo.title : this.state.selectedSlideIndex;
            var originalAlt = (rawInfo.caption) ? rawInfo.caption : rawInfo.descript;
            var descript = (rawInfo.descript) ? rawInfo.descript : "";
            var tags = (rawInfo.tags) ? rawInfo.tags : [];
            return { "original": original, "originalTitle": originalTitle, "originalAlt": originalAlt, "descript": descript, "tags": tags, "ext": ext };
        });
        return result;
    }

    onSlide(currentIndex) {
        this.setState({ selectedSlideIndex: currentIndex });
    }

    onDownloadSelectedImage(e) {
        e.preventDefault();
        if (this.state.hasSlides) {
            var imageUrl = this.state.slides[this.state.selectedSlideIndex].original;
            fetch(imageUrl).then(response => {
                response.blob().then(blob => {
                    // Creating new object of PDF file
                    const fileURL = window.URL.createObjectURL(blob);
                    // Setting various property values
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = this.state.selectedObservationId + "-" + this.state.selectedSlideIndex + "." + this.state.slides[this.state.selectedSlideIndex].ext;
                    alink.click();
                })
            });
            this.props.onToastRequest("success", "File downloaded.");

        }
    }




    onDownloadFileFromString(fileStringContents, fileName, fileType)
    {
        try
        {
            const link = document.createElement("a");
            const file = new Blob([fileStringContents], { type: fileType });
            link.href = URL.createObjectURL(file);
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(link.href);
            return new ServiceResponse(false, fileName + " created successfully.");
        }
        catch(e)
        {
            return new ServiceResponse(true,   "Error creating file " + fileName + " [" + e.message + "]");
        }
    }

    onDownloadAsJsonRequest(requestData, isFlat = false)
    {
        try
        {
            var historySchemaId = this.state.searchParams.schemaId;
            var schema = this.localStorageService.getSchema(historySchemaId);
            if (!schema.dataApi?.active)
            {
                this.props.onToastRequest("warning", "Schema " + historySchemaId + " does not currently support Data Downloading.");
                return;
            }
            var jsonString = "";
            var jsonFlName = "";
            var rawDataList = (requestData) ? requestData : [this.state.selectedObservation];

            var conformedDataResponse = DataTransformManager.transformGradedObservations(rawDataList, historySchemaId, schema, isFlat);
            if (conformedDataResponse.hasError)
            {
                this.props.onToastRequest("error", "There was a problem generating your data download. Please report the following error to your Application Administrator -[" + conformedDataResponse.messages.join(" ") + "]");
                return;
            }
            if (requestData)
            {
                jsonString = JSON.stringify(conformedDataResponse.data[0].data);
                jsonFlName = conformedDataResponse.data[0].type;
            }
            else // user only wants to the current selection
            {
                jsonString = JSON.stringify(this.state.selectedObservation);
                jsonFlName = "observation-" + this.state.selectedObservation?.identifiers?.id ?? "noid";
            }
            jsonFlName = jsonFlName + ".json";
            var downloadResponse = this.onDownloadFileFromString(jsonString, jsonFlName, "application/json");
            if (downloadResponse.hasError)
            {
                this.props.onToastRequest("error", downloadResponse.messages);
            }
            else 
            {
                    this.props.onToastRequest("success", "Data has been downloaded as " + jsonFlName);
            }
        }
        catch(e)
        {
            this.props.onToastRequest("error", "There was a problem generating your data download. Please report the following error to your Application Administrator -[" + e.message + "]");
        }

    }

    
    // {type: "", data: []};
    onDownloadAsStarJsonRequest(requestData)
    {
        try
        {
            var historySchemaId = this.state.searchParams.schemaId;
            var schema = this.localStorageService.getSchema(historySchemaId);
            if (!schema.dataApi?.active)
            {
                this.props.onToastRequest("warning", "Schema " + historySchemaId + " does not currently support Data Downloading.");
                return;
            }

            var rawDataList = requestData;
            // in the case of the "star" schema, we actually download three files - the base fact file and the two dimensions - category and defects
            var conformedDataResponse = DataTransformManager.transformStarGradedObservations(rawDataList, historySchemaId, schema);
            if (conformedDataResponse.hasError)
            {
                this.props.onToastRequest("error", "There was a problem generating your data download. Please report the following error to your Application Administrator -[" + conformedDataResponse.messages.join(" ") + "]");
                return;
            };

            // output each file
            conformedDataResponse.data.forEach((dataset) => {
                var downloadResponse = this.onDownloadFileFromString(JSON.stringify(dataset.data), dataset.type + ".json", "application/json");
                if (downloadResponse.hasError)
                {
                    this.props.onToastRequest("error", "There was a problem generating the download file for the " + dataset.type + " file. Please report the following error to your Application Administrator - [" + 
                        downloadResponse.messages.join(" ") + "]");
                }
                else 
                {
                    this.props.onToastRequest("success", dataset.type + ".json was successfully downloaded.");
                }
            });
        }
        catch(e)
        {
            this.props.onToastRequest("error", "There was a problem generating your data download. Please report the following error to your Application Administrator -[" + e.message + "]");
        }


    }

    async onUploadAsJsonRequest(requestData)
    {
        try
        {
            var historySchemaId = this.state.searchParams.schemaId;
            var schema = this.localStorageService.getSchema(historySchemaId);
            if (!schema.dataApi?.active)
            {
                this.props.onToastRequest("warning", "Schema " + historySchemaId + " does not currently support Data Uploading.");
                return;
            }


            var dataApiManager = new DataApiManager();
            var response = await dataApiManager.onUploadAsJsonRequest(schema, requestData, this.props.userSession);
            if (response.hasError)
            {
                this.props.onToastRequest("error", response.toMessageString());
            }
            else
            {
                this.props.onToastRequest("success", "Observation Fact Data uploaded successfully!");
            }
        }
        catch(e)
        {
            this.props.onToastRequest("error", "There was a problem uploading data. Please report the following error to your Application Administrator -[" + e.message + "]");
        }
    }

    async onUploadDimensionsAsJsonRequest()
    {
        try
        {
            var historySchemaId = this.state.searchParams.schemaId;
            var schema = this.localStorageService.getSchema(historySchemaId);
            if (!schema.dataApi?.active)
            {
                this.props.onToastRequest("warning", "Schema " + historySchemaId + " does not currently support Data Uploading.");
                return;
            }

            var dataApiManager = new DataApiManager();
            var response = await dataApiManager.onUploadDimensionsAsJsonRequest(schema, this.props.userSession);
            if (response.hasError)
            {
                this.props.onToastRequest("error", response.toMessageString())
            }
            else
            {
                this.props.onToastRequest("success", "Observation Dimension Data uploaded successfully!");
            }
        }
        catch(e)
        {
            this.props.onToastRequest("error", "There was a problem uploading data. Please report the following error to your Application Administrator -[" + e.message + "]");
        }
    }



    render() {
        //var rankings = (this.state.searchParams && this.props.showCharts && this.state.schema?.ranking) ? this.state.schema?.ranking?.rankings : [];

        var showFileViewer = (this.state.showUserDocBox);
        if (showFileViewer)
        {
            var obs = this.state.selectedObservation;
        }

        var gridTitle = (this.props.parentComponent === "dashboard") ? "Chart Filters": "History Grid";
        var hasGridFilter = ((this.props.globalFilterParams) && (Object.keys(this.props.globalFilterParams).length > 0));

        return (



            <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='15px'>
                <HStack direction='row'>
                    <Text fontSize={{ base: '28px', md: '32px', lg: '36px' }} color='white'>{gridTitle}</Text>
                    <Spacer />
                    <Tag size={'sm'} key={'sm'} variant={(hasGridFilter) ? 'solid' : 'outline'} colorScheme={(hasGridFilter) ? 'green' : 'gray'}>
                        <TagLabel>{(hasGridFilter) ? 'Filter ON' : 'Filter OFF'}</TagLabel>
                    </Tag>
                    <FormLabel htmlFor='autorefreshswitch' mb='0' color='white'>auto-refresh</FormLabel>
                    <Switch id="autorefreshswitch" defaultChecked={(this.props.autoRefresh)} size='lg' colorScheme='green'  onChange={(e) => this.props.onToggleAutoRefresh(e)} />
                    {this.state.suppressAutoRefresh && 
                        <FontAwesomeIcon icon={faCircle} color="lightred"/>
                    }

                </HStack>


                <HistorySearchStrip
                    userSession={this.props.userSession}
                    currentSchemaId={this.props.currentSchemaId}
                    searchParams={this.state.searchParams}
                    searchParamsKey={this.state.searchParamsKey}
                    onSearchParamsChange={this.onSearchParamsChange}
                    onErrorPageRequest={this.props.onErrorPageRequest}
                    parentComponent={this.props.parentComponent}
                />

                {/* <Box height="10vh"/> */}

                {
                    ((this.state.searchParams) && (this.props.showCharts) && (this.props.currentSchemaId) && (this.state.searchParamsKey) && (this.props.orgConfig?.dashboardConfig?.charts?.filteredCountPieChart)) &&
                    <HStack alignItems={"flex-start"} justifyContent={"space-evenly"}>


                        {
                            (this.props.orgConfig.dashboardConfig.charts.filteredCountPieChart.map((chart) =>
                            {
                                return <FilteredCountPieChart
                                userSession={this.props.userSession}
                                searchParams={this.state.searchParams}
                                searchParamsKey={this.state.searchParamsKey}
                                currentSchemaId={this.props.currentSchemaId}
                                countProp={chart.countProp}
                                title={chart.title}
                            />
                            }))
                        }

                    {/*
                        <FilteredCountPieChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            countProp={{ "Id": "scoreGrade", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Grades Percentage"}
                        />

                        <FilteredCountPieChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            countProp={{ "Id": "observationLocation", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Observations by Location"}
                        />

                        <FilteredCountPieChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            countProp={{ "Id": "observedBy", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Observations by Inspector"}
                        />
                    */}

                    </HStack>

                }




                {((this.state.searchParams) && (this.props.showCharts) && (this.props.currentSchemaId) && (this.state.searchParamsKey) &&  (this.props.orgConfig?.dashboardConfig?.charts?.filteredCountPartitionStackedBarChart)) &&
                    <VStack>

                        {
                            (this.props.orgConfig.dashboardConfig.charts.filteredCountPartitionStackedBarChart.map((chart) =>
                            {
                                return <FilteredCountPartitionStackedBarChart
                                    userSession={this.props.userSession}
                                    searchParams={this.state.searchParams}
                                    searchParamsKey={this.state.searchParamsKey}
                                    currentSchemaId={this.props.currentSchemaId}
                                    colorMap={this.state.gradeColorMap}
                                    partitionProp={chart.partitionProp}
                                    countProp={chart.countProp}
                                    title={chart.title}
                                />
                            }))
                        }

                    {/*
                        <FilteredCountPartitionStackedBarChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            colorMap={this.state.gradeColorMap}
                            partitionProp={{ "Id": "countryoforigin", "IsBaseProp": false, "JsonPath": "data.UnderInspection.CountryOfOrigin" }}
                            countProp={{ "Id": "scoreGrade", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Grade by Country of Origin"}
                        />

     


                        <FilteredCountPartitionStackedBarChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            colorMap={this.state.gradeColorMap}
                            partitionProp={{ "Id": "supplier", "IsBaseProp": false, "JsonPath": "data.UnderInspection.Supplier" }}
                            countProp={{ "Id": "scoreGrade", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Grade by Supplier"}
                        />

                  

                        <FilteredCountPartitionStackedBarChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            colorMap={this.state.gradeColorMap}
                            partitionProp={{ "Id": "growerId", "IsBaseProp": false, "JsonPath": "data.UnderInspection.GrowerID" }}
                            countProp={{ "Id": "scoreGrade", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Grade by Grower ID"}
                        />

          

                        <FilteredCountPartitionStackedBarChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            colorMap={this.state.gradeColorMap}
                            partitionProp={{ "Id": "observationLocation", "IsBaseProp": true, "JsonPath": "" }}
                            countProp={{ "Id": "scoreGrade", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Grade by Location"}
                        />


                        <FilteredCountPartitionStackedBarChart
                            userSession={this.props.userSession}
                            searchParams={this.state.searchParams}
                            searchParamsKey={this.state.searchParamsKey}
                            currentSchemaId={this.props.currentSchemaId}
                            colorMap={this.state.gradeColorMap}
                            partitionProp={{ "Id": "observedBy", "IsBaseProp": true, "JsonPath": "" }}
                            countProp={{ "Id": "scoreGrade", "IsBaseProp": true, "JsonPath": "" }}
                            title={"Grade by Inspector"}
                        />
                        
                    */}

                    </VStack>
                }




                {((this.state.searchParams) && (this.props.showCharts) && (this.props.currentSchemaId)) &&
                    <EnterpriseActivityChart
                        title="Filtered Activity Chart"
                        showLegend={false}
                        userSession={this.props.userSession}
                        searchParams={this.state.searchParams}
                        searchParamsKey={this.state.searchParamsKey}
                        currentSchemaId={this.props.currentSchemaId}
                    />
                }





                <HistoryGrid
                    userSession={this.props.userSession}
                    onToastRequest={this.props.onToastRequest}
                    onMsgBoxRequest={this.props.onMsgBoxRequest}
                    currentSchemaId={this.state.searchParams.schemaId}
                    searchParams={this.state.searchParams}
                    searchParamsKey={this.state.searchParamsKey}
                    onErrorPageRequest={this.props.onErrorPageRequest}
                    onObservationSelectionChanged={this.onObservationSelectionChanged}
                    currentObservation={this.state.selectedObservation}
                    onShowUserImageBox={this.onShowUserImageBox}
                    onShowUserDocBox={this.onShowUserDocBox}
                    onShowPdfReport={this.onShowPdfReport}
                    onResendSubscriptionNotificationsRequest={this.onResendSubscriptionNotificationsRequest}
                    onDownloadAsJsonRequest={this.onDownloadAsJsonRequest}
                    onDownloadAsStarJsonRequest={this.onDownloadAsStarJsonRequest}
                    onUploadAsJsonRequest={this.onUploadAsJsonRequest}
                    onUploadDimensionsAsJsonRequest={this.onUploadDimensionsAsJsonRequest}
                    onShowShareBox={this.onShowShareBox}
                    schemaReports={this.state.schemaReports}
                    onVoidRequest={this.onVoidRequest}
                    onCopyRequest={this.onCopyRequest}
                    onDuplicateRequest={this.onDuplicateRequest}
                    onViewReadOnlyRequest={this.onViewReadOnlyRequest}
                    onUpdateRequest={this.onUpdateRequest}
                    onWorkflowStepRequest={this.onWorkflowStepRequest} 
                    autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
                    suppressAutoRefresh={this.state.suppressAutoRefresh}
                    parentComponent={this.props.parentComponent}
                    globalFilterParams={this.props.globalFilterParams}
                    onGlobalFilterParamsChange={this.props.onGlobalFilterParamsChange}
                />

                <ShareDialog
                    userSession={this.props.userSession}
                    onToastRequest={this.props.onToastRequest}
                    showShareBox={this.state.showShareBox}
                    closeShareBox={this.onCloseShareBox}
                    currentObservation={this.state.selectedObservation}
                    currentSchemaId={this.props.currentSchemaId}
                    schemaReports={this.state.schemaReports}
                />



                <Modal isOpen={this.state.showUserImageBox} onClose={() => { this.onCloseUserImageBox() }}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalBody>
                            <Box rounded="20px" overflow="hidden" bg={this.state.colorMode === "dark" ? "gray.700" : "gray.200"} mt={10}>
                                <ImageGallery
                                    lazyLoad={true}
                                    items={(this.state.hasSlides) ? this.state.slides : []}
                                    showBullets={false}
                                    showIndex={true}
                                    showThumbnails={true}
                                    onErrorImageURL={ImageNotFound}
                                    onSlide={this.onSlide}
                                />
                                <Box p={5}>
                                    <Stack align="center">
                                        <Text as="h2" fontWeight="normal" my={2} >
                                            {(this.state.hasSlides && this.state.slides[this.state.selectedSlideIndex].title) ? 
                                                 this.state.slides[this.state.selectedSlideIndex].title : "User Image"
                                            }
                                        </Text>
                                        <Text fontWeight="light">
                                            {(this.state.hasSlides && this.state.slides[this.state.selectedSlideIndex]?.descript) ? 
                                                this.state.slides[this.state.selectedSlideIndex].descript : "No description"
                                            }
                                        </Text>
                                        {((this.state.hasSlides) && (this.state.slides[this.state.selectedSlideIndex].tags)) &&
                                        <HStack spacing={4}>
                                            {this.state.slides[this.state.selectedSlideIndex]?.tags.map((tag) => <Tag size='sm' key={tag.value} variant='solid' colorScheme='teal'>{tag.label}</Tag>)}
                                        </HStack>
                                        }
                                    </Stack>
                                </Box>

                            </Box>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={(e) => this.onDownloadSelectedImage(e)}
                                leftIcon={<FontAwesomeIcon icon={faDownload} />}
                                variant='ghost'>
                                Download Image
                            </Button>
                            <Button colorScheme='blue' mr={3} onClick={() => this.onCloseUserImageBox()}>Close</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

            {/*
                <UserFileViewerModal
                    userSession={this.props.userSession}
                    show={this.state.showUserDocBox}
                    onClose={this.onCloseUserDocBox}
                    docs={this.state.selectedObservation?.data?.Raw?.userdocs}
                />
                                    */}

                {/*
                <Modal isOpen={this.state.showUserDocBox} onClose={() => this.closeUserDocBox}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalBody>
                            <Box rounded="20px" overflow="hidden" bg={this.state.colorMode === "dark" ? "gray.700" : "gray.200"} mt={10}>
                                <DocViewer
                                    documents={(this.state.docs) ? this.state.docs : []}
                                    activeDocument={(this.state.docs) ? this.state.docs[0] :  {uri: ""}}
                                    pluginRenderers={DocViewerRenderers}
                                />
                            </Box>
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme='blue' mr={3} onClick={() => this.onCloseUserDocBox()}>Close</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                */}
            


                <ModalIdNameListDialog
                    show={this.state.showVoidBox}
                    title="Void"
                    placeholder="Select a Void Reason"
                    onModalCloseRequest={this.onCloseVoidBox}
                    onModalOkRequest={this.onOkVoidBox}
                    existingValue={""}
                    dataList={this.state.voidIdNameList ?? []}

                />



                {this.state.selectedObservation &&
                    <ObservationDetailPanel
                        userSession={this.props.userSession}
                        currentObservation={this.state.selectedObservation}
                        onErrorPageRequest={this.props.onErrorPageRequest}
                    />
                }

            </Box>
        );

    }




}